import RewardSummaryList from "./RewardSummaryList.jsx";

function CheckoutSummary({ selections, driverProfile }) {
  if (!Array.isArray(selections) || !selections.length) return null;

  return (
    <aside className="landstar-summary-card">
      <p className="landstar-kicker">Order Summary</p>
      <RewardSummaryList products={selections} />

      <div className="landstar-driver-summary-row landstar-summary-metadata">
        <div className="landstar-driver-summary-item">
          <span className="landstar-driver-summary-label">Tier</span>
          <strong>{driverProfile.rewardTier}</strong>
        </div>

        <div className="landstar-driver-summary-item">
          <span className="landstar-driver-summary-label">L-Number</span>
          <strong>{driverProfile.lNumber}</strong>
        </div>
      </div>

      <p className="landstar-helper-text">
        Shipping details below will be used for the selected rewards and staged for final processing.
      </p>
    </aside>
  );
}

export default CheckoutSummary;
